import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
// Custom components
import Caption from '../../../components/Caption';
// Messages translated
import messages from './messages';

const CardLink = styled(NavLink)`
  ${tw`flex mt-def p-def cursor-pointer text-text
    relative rounded-lg shadow no-underline`};
`;

const Body = styled.div`
  ${tw`flex flex-col w-full`}
`;

const AnswerText = styled(Caption)`
  ${tw`text-right text-terciary500 font-medium`}
  font-size: 1.5rem;
  text-decoration: none;
  bottom: 5px;
  right: 5px;
`;

const Question = ({ question }) => (
  <CardLink id={question.name} to={`/faq/${question.name}`}>
    <Body>
      <p>{question.title}</p>
      <AnswerText>
        <FormattedMessage {...messages.checkAnswer} />
      </AnswerText>
    </Body>
  </CardLink>
);

Question.propTypes = {
  question: PropTypes.object,
};

export default Question;
